interface ChatMessage {
    role: string;
    content: string;
    created_at: string;
}

interface ChatData {
    chatId: string;
    agentId?: string;
    messages: ChatMessage[];
}

export const generateCsvFromChats = (chatsData: ChatData[], agentId: string): string => {
    const allMessages: string[][] = [];
    const chatIdSet = new Set<string>();
    let totalMessages = 0;
    const lastMsgMap: Record<string, { role: string; content: string }> = {};

    for (const chat of chatsData) {
        const messages = chat.messages || [];

        if (messages.length === 0) {
            continue;
        }

        chatIdSet.add(chat.chatId);

        for (const msg of messages) {
            const role = msg.role;
            const content = (msg.content || '').trim();

            const last = lastMsgMap[chat.chatId] || {};
            const isDuplicateBlankAssistant =
                role === 'assistant' && content === '' && last.role === 'assistant' && (last.content || '').trim() === '';

            if (isDuplicateBlankAssistant) {
                continue;
            }

            allMessages.push([chat.chatId, msg.created_at, role, msg.content || '']);
            lastMsgMap[chat.chatId] = { role, content };
            totalMessages++;
        }
    }

    if (allMessages.length === 0) {
        return '';
    }

    const csvRows: string[] = [];

    csvRows.push(`Agent ID: ${agentId}`);
    csvRows.push('chat_id,created_at,role,content');

    allMessages.forEach(row => {
        csvRows.push(row.map(cell => escapeCsvField(cell)).join(','));
    });

    // Empty row separator
    csvRows.push('');
    csvRows.push('');
    csvRows.push('');

    csvRows.push(escapeCsvField('# Summary'));
    csvRows.push([escapeCsvField('Total messages extracted'), totalMessages.toString()].join(','));
    csvRows.push([escapeCsvField('Unique chat IDs'), chatIdSet.size.toString()].join(','));

    return csvRows.join('\n');
};

const escapeCsvField = (field: string): string => {
    if (!field) return '""';

    // If field contains comma, quote, or newline, wrap in quotes and escape internal quotes
    if (field.includes(',') || field.includes('"') || field.includes('\n') || field.includes('\r')) {
        return `"${field.replace(/"/g, '""')}"`;
    }

    return field;
};

export const createCsvBlobUrl = (csvContent: string): string => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    return URL.createObjectURL(blob);
};
